export const parseAgcCheckQuestions = (response, questions) => {
  const parsedQuestions = questions.map((q) => {
    if (response.hasOwnProperty(q.name)) {
      return {
        ...q,
        value: response[q.name],
      };
    }
    return q;
  });
  return parsedQuestions;
};

export const convertQuestionsToResponse = (parsedQuestions) => {
  const response = {};
  parsedQuestions.forEach((q) => {
    if (q.hasOwnProperty("value")) {
      response[q.name] = q.value;
    }
  });
  return response;
};
